import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   data: [],
};

const starredMessagesSlice = createSlice({
   name: 'starredMessagesData',
   initialState,
   reducers: {
      setStarredMessages(state, action) {
         state.data = action.payload;
      },

      addStarredMessage(state, action) {
         const message = action.payload;
         const msgId = message.msgId || message.messageId;
         const exists = state.data.some(m => m.msgId === msgId);
         if (!exists) {
            state.data.unshift(message);
         }
      },

      removeStarredMessage(state, action) {
         const msgId = action.payload;
         state.data = state.data.filter(m => m.msgId !== msgId);
      },

      clearStarredMessagesByChat(state, action) {
         const { chatJid } = action.payload;
         state.data = state.data.filter(msg => msg.chatJid !== chatJid && msg.fromUserJid !== chatJid);
      },

      updateStarredMessageStatus(state, action) {
         const { msgId, updatedConversationMessage } = action.payload;
         const index = state.data.findIndex(m => m.msgId === msgId);
         if (index !== -1 && updatedConversationMessage) {
            state.data[index] = updatedConversationMessage;
         }
      },

      deleteStarredMessages(state, action) {
         const { msgIds } = action.payload;
         state.data = state.data.filter(m => {
            const idToUse = m.msgId || '';
            return !msgIds.some(id => idToUse === id || idToUse.startsWith(id + '-'));
         });
      },

      recallStarredMessages(state, action) {
         const { msgIds } = action.payload;
         state.data = state.data.map(m => {
            if (msgIds.includes(m.msgId)) {
               return { ...m, deleteStatus: 1 };
            }
            return m;
         });
      },

      updateStarredMessage(state, action) {
         const { msgId, msgBody, msgStatus, editMessageId, editedStatus } = action.payload;
         const index = state.data.findIndex(m => m.msgId === msgId);
         if (index !== -1) {
            const message = state.data[index];
            if (msgBody) message.msgBody = { ...message.msgBody, ...msgBody };
            if (msgStatus !== undefined) message.msgStatus = msgStatus;
            if (editedStatus !== undefined) message.editedStatus = editedStatus;
            message.editMessageId = editMessageId;
         }
      },
   },
});

export const {
   setStarredMessages,
   addStarredMessage,
   removeStarredMessage,
   clearStarredMessagesByChat,
   updateStarredMessageStatus,
   deleteStarredMessages,
   recallStarredMessages,
   updateStarredMessage,
} = starredMessagesSlice.actions;

export const { reducer: starredMessagesReducer } = starredMessagesSlice;
export default starredMessagesSlice;
